<template>
    <div id="assignPickLocToUser">

        <a-modal v-model="visible" :footer="null" title="分配拣货人" width="40%">
            <a-form :form="locationFormQuery">
                <a-row >
                    <a-col span="3" offset="1">
                        <a-form-item  class="genericFrom">
                            <a-row ><b> </b><br/></a-row>
                            <a-row >
                                <a-button class="fonterButton" type="primary" size="small" @click="assignPickLocToUser">{{ $t('reportSetting.Assign') }}</a-button >
                            </a-row>
                        </a-form-item>
                    </a-col>
                    <a-col span="6" offset="1">
                        <a-form-item  class="genericFrom">
                            <b>{{ $t('invTrans.locFrom') }}:</b>
                            <a-input size="small" v-model="locationFrom" @pressEnter="queryLocation"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col span="6" offset="1">
                        <a-form-item  class="genericFrom">
                            <b>{{ $t('invTrans.locTo') }}:</b>
                            <a-input size="small" v-model="locationTo" @pressEnter="queryLocation"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col span="3" offset="1">
                        <a-form-item  class="genericFrom">
                            <a-row ><b>{{ $t('showAll') }}</b><br/></a-row>
                            <a-row >
                                <a-checkbox size="small" v-model="isShowAll" @change="changeShowAll"> </a-checkbox>
                            </a-row>
                        </a-form-item>
                    </a-col>

                </a-row>
            </a-form>
            <a-row>
                <vxe-table
                        border
                        resizable
                        column-key
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                        :sort-config="{multiple: true, trigger: 'cell'}"
                        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                        :checkbox-config="{trigger:'row',highlight:false,range:true}"
                        keep-source
                        :keyboard-config="{isArrow: true}"
                        align="center"
                        :data.sync="pickLocationList"
                        class="mytable-style"
                        :height="250"
                        ref="refPickLocationGrid"
                        size="mini">
                    <template v-slot:empty>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column field="Location_code" :title="$t('batchReceive.LocationCode')" sortable></vxe-table-column>
                    <vxe-table-column field="PICK_ACCOUNT" :title="$t('reportSetting.AssignName')" sortable></vxe-table-column>
                </vxe-table>
            </a-row>

        </a-modal>


        <a-modal title="用户信息" v-model="displayUserModel" width="50%">

            <a-form :form="userFormQuery">
                <a-row>
                    <a-col :span = "6" offset="1">
                        <a-form-item  class="genericFrom">
                            <b>{{ $t('userlang.UserAccount') }}</b>
                            <a-input size="small" v-decorator="['loginAccount']" @pressEnter="queryUserInfo"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span = "6" offset="1">
                        <a-form-item class="genericFrom">
                            <b>{{ $t('userlang.DisplayName') }}:</b>
                            <a-input size="small" v-decorator="['dispName']" @pressEnter="queryUserInfo"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="1" offset="1">
                        <a-form-item  class="genericFrom">
                            <b>&nbsp; </b>
                            <a-button  type="primary" @click="queryUserInfo">{{ $t('pubGicSet.query') }}</a-button>
                        </a-form-item>
                    </a-col>
                    <a-col :span="1" offset="1">
                        <a-form-item  class="genericFrom">
                            <b> &nbsp;</b>
                            <a-button  type="primary" @click="resetUserInfo">{{ $t('pubGicSet.reset') }}</a-button>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
            <template slot="footer">
                <a-button  type="primary" @click="setPickerToLocation">{{ $t('userlang.Save') }}</a-button>
            </template>
            <vxe-table
                    stripe
                    highlight-hover-row
                    border
                    resizable
                    size="mini"
                    :data="orgUserList"
                    ref="orgUserTableRef"
                    max-height="250"
            >
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('userlang.NorecordFound') }}</span>
                </template>
                <vxe-table-column  type="checkbox" width="60"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="loginId" :title="$t('userlang.UserAccount')"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="dispName" :title="$t('userlang.DisplayName')"></vxe-table-column>

            </vxe-table>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data() {
            return{
                pickLocationList: [],//列表数据
                visible:false,
                orderNo:"",
                locationFrom:"",
                locationTo:"",
                isShowAll:false,
                locationFormQuery:this.$form.createForm(this),
                userFormQuery: this.$form.createForm(this),
                displayUserModel:false,
                orgUserList:[],
            }
        },

        methods:{
            show(orderNo) {
                this.orderNo = orderNo
                this.visible = true;
                this.locationFormQuery.resetFields();
                this.locationFrom="";
                this.locationTo="";
                this.isShowAll = false;
                this.queryLocation();
            },
            queryLocation(){
                let showAll = "false";
                if(this.isShowAll){
                    showAll = "true";
                }
                let locationFrom = this.locationFrom;
                let locationTo = this.locationTo;
                console.log("locationFrom:"+locationFrom);
                console.log("locationTo:"+locationTo);
                let params = new FormData();
                params.append("relId", this.orderNo);
                params.append("locationFrom", locationFrom);
                params.append("locationTo", locationTo);
                params.append("showAll", showAll);
                ajax.post(api.GETPICKLOCATIONLISTBYSO, params).then(res => {
                    if (res.code == 200) {
                        this.pickLocationList = res.data;
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                });
            },
            changeShowAll(){
                this.queryLocation();
            },
            assignPickLocToUser(){
                let pickLocCheckedList = this.$refs.refPickLocationGrid.getCheckboxRecords();
                if (pickLocCheckedList.length <1) {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                    return;
                }
                this.displayUserModel=true;
                this.resetUserInfo();
            },
            cancel(){
                this.visible = false;
            },
            queryUserInfo(){
                this.userFormQuery.validateFields((err, val) => {
                    if (!err) {
                        let params = {};
                        params = val;
                        ajax.get(api.GETUSERLISTBYORGCODE, params).then(res => {
                            this.orgUserList = res.data
                        });
                    }
                });

            },
            resetUserInfo(){
                this.userFormQuery.resetFields();
                this.queryUserInfo();
            },
            setPickerToLocation(){
                let orgUserCheckedList = this.$refs.orgUserTableRef.getCheckboxRecords();
                if (orgUserCheckedList.length !=1) {
                    this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                    return;
                }
                let pickLocCheckedList = this.$refs.refPickLocationGrid.getCheckboxRecords();
                let locationList = [];
                for(let t in pickLocCheckedList){
                    locationList.push(pickLocCheckedList[t].Location_code);
                }

                let params = new FormData();
                params.append("relId",this.orderNo);
                params.append("locationList",locationList);
                params.append("loginId", orgUserCheckedList[0].loginId);
                ajax.post(api.SETUSERTOPICKLOCATION, params).then(res => {
                    if (res.code == 200) {
                        this.displayUserModel=false;
                        this.changeShowAll();
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                });

            },
        }
    }
</script>